import { Check } from "lucide-react";
import { CtaPanel, Layout, PageIntro } from "../components/Chrome";
import { MaskedLines, Reveal } from "../components/Motion";

const beliefs = [
  "Relevance over random reach",
  "Authentic creator-brand alignment",
  "Campaign-specific creator selection",
  "Regional and language-based creator discovery",
  "End-to-end campaign coordination",
];

export default function About() {
  return (
    <Layout>
      <PageIntro
        eyebrow="About Moon Media"
        lines={[<>The right creator can</>, <>change the way a <em>brand is seen.</em></>]}
        text="We work at the intersection of brands, creators and audiences — making the space between them more meaningful."
      />
      <section className="about-split section-pad">
        <div className="about-sticky">
          <Reveal as="span" className="eyebrow" y={14}>Why Moon?</Reveal>
          <MaskedLines as="h2" inView lines={[<>Connection finds</>, <>its own <em>light.</em></>]} />
        </div>
        <div className="about-copy">
          <Reveal as="p" className="about-lead">Moon Media is inspired by the idea of creating genuine human connection and finding the right light for every brand story. Our work is thoughtful, human and grounded in the belief that relevance creates stronger connection than random reach.</Reveal>
          <Reveal as="p" delay={0.15}>Every brief is answered with a curated shortlist — creators whose audience, language, content style and geography genuinely align with what the campaign is trying to achieve.</Reveal>
          <ul className="check-list">
            {beliefs.map((item, i) => (
              <Reveal as="li" key={item} delay={0.1 + i * 0.07} y={18} data-testid={`about-belief-${i + 1}`}>
                <Check size={17} />{item}
              </Reveal>
            ))}
          </ul>
        </div>
      </section>
      <CtaPanel eyebrow="A better match starts here" lines={[<>Bring us the brief.</>, <>We’ll bring <em>the people.</em></>]}>Tell Us Your Brief</CtaPanel>
    </Layout>
  );
}
